<template>
  <div class="index-module_articleWrap_2Zphx">
      <div class="zhemo">李录北大演讲：价值投资在中国行得通</div>
    
    <p class='index-module_textWrap_3ygOc'>
      李录<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >美国喜马拉雅资本创始人<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >真正的价值投资理念的践行者<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >目前管理 50 亿美元资产<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >是查理•芒格家族资产的主要管理者<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      本文系李录在北大的一篇演讲实录<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >李录在文中探讨了成功投资者应该具备什么素质<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >如何在长期内保持稳定的收益以及价值投资在中国的前景等问题<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      以下为演讲内容的精华版<span
        unicode="ff1a"
        class="biaodian cjk bd-end bd-jiya bd-consecutive"
        ><span>：</span></span
      ><span
        unicode="ff08"
        class="biaodian cjk bd-open bd-jiya bd-consecutive end-portion"
        prev="bd-end"
        ><span>（</span></span
      >有所删减<span unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"
        ><span>）</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      价值投资课<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这个课程在全球也不多<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >据我所知只有哥伦比亚大学有这样一门课<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >大概在八九十年前由巴菲特的老师本杰明•格雷厄姆最早开设<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >今天在这里主要想跟各位同学探讨三个问题<span
        unicode="ff1a"
        class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      >
    </p>
    <h4 class="szhuang">
      <b
        >NO1:长期看<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >哪些金融资产可以让财富持续<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >有效<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >安全可靠地增长<span unicode="ff1f" class="biaodian cjk bd-end bd-jiya"
          ><span>？</span></span
        ></b
      >
    </h4>
    <p class='index-module_textWrap_3ygOc'>
      我们刚经历了股灾<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >很多人觉得现金是最可靠的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >甚至很多人觉得黄金也是很可靠的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我们有没有办法衡量过去这些资产的长期表现到底是什么样的<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >那么长期指的是多长时间呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      在我看来就是越长越好<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我们能够找到的数据<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >时间越久越好<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >最好是长期<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >持续的数据<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >因为只有这样的数据才能真正有说服力<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这里我们选用美国的数据<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      ><br />
    </p>
    <p class='index-module_textWrap_3ygOc'>
      宾州大学沃顿商学院的西格尔教授<span
        unicode="ff08"
        class="biaodian cjk bd-open bd-jiya"
        ><span>（</span></span
      >Seigel<span unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"
        ><span>）</span></span
      >在过去几十年里兢兢业业<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >认真地收集了美国在过去几百年里各个大类金融资产的表现<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >把它绘制成图表<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >给了我们非常可靠的数据来检验<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这些数据可以可靠地回溯到1802年<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >今天我们就来看一下<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >在过去两百多年的时间里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >各类资产表现如何呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      1<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >第一大类资产是现金
    </p>
    <p class='index-module_textWrap_3ygOc'>
      如果 1802 年你有一美金<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >今天这一美金值多少钱<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >它的购买力是多少<span unicode="ff1f" class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >答案是 5 分钱<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >两百多年之后一块钱现金丢掉了 95% 的价值购买力<span
        unicode="ff01"
        class="biaodian cjk bd-end bd-jiya"
        ><span>！</span></span
      >原因我们大家都可以猜到<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这是因为通货膨胀<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      2<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >第二大类是黄金等贵金属
    </p>
    <p class='index-module_textWrap_3ygOc'>
      对传统中国人来说<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >黄金<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >白银<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >重金属也是一个非常好的保值的方式<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >西方发达国家在相当长的一段时间里一直实行金本位<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >黄金的价格确实增长了<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但进入 20 世纪我们看到它的价格开始不断在下降<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我们来看一看黄金作为贵重金属里最重要的代表在过去两百年的表现<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >在两百年前用一块美金购买的黄金<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >今天能有多少购买力<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我们看到的结果是 3.12 块美金<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这显然确实是保了值了<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但是如果说在两百年里升值了 3<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >4 倍<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这个结果也是很出乎大家预料的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >并没有取得太大增值<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      3<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >第三大类是债券
    </p>
    <p class='index-module_textWrap_3ygOc'>
      再来看短期政府债券和长期债券<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >短期政府债券的利率相当于无风险利率<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >一直不太高<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >稍稍高过通货膨胀<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >短期债券两百年涨了 275 倍<span
        unicode="ff1b"
        class="biaodian cjk bd-end bd-jiya"
        ><span>；</span></span
      >长期债券的回报率比短期债券多一些<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >涨了 1600 多倍<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      4<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >再看一看股票<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >它是另外一个大类资产<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      可能很多人认为股票更加有风险<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >更加不能保值<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票在过去两百年的表现如何<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我们现在看到的结果是<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >1 块钱股票<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >即使除掉通货膨胀因素之后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >在过去两百年里仍然升值了一百万倍<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >今天它的价值是 103 万<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >它的零头都大于其他大类资产<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      为什么会是这样惊人的结果呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >这个结果实际上具体到每一年的增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >除去通货膨胀的影响<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >年化回报率只有 6.7%<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这就是复利的力量<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >爱因斯坦把复利称之为世界第八大奇迹是有道理的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      上面这些数字给我们提出了一个问题<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >为什么现金被大家认为最保险<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >反而在两百年里面丢失了 95% 的价值<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而被大家认为风险最大的资产股票则增加了将近一百万倍<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >一百万倍是指扣除通货膨胀之后的增值<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      为什么现金和股票的回报表现在两百年里面出现了这么巨大的差距<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      造成这个现象有两个原因<span
        unicode="ff1a"
        class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      一个原因是通货膨胀<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >通货膨胀在美国过去两百年里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >平均年化是 1.4% 左右<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >如果通货膨胀每年以 1.4% 的速度增长的话<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你的购买力确实是每年在以 1.4% 的速度在降低<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >经过两百年之后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就让 1 块钱变成了 5 分钱<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >丢失了 95%<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >现金的价值几乎消失了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      另外一个原因<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就是GDP增长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >GDP在过去两百年里大约增长了 33000 多倍<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >年化大约 3% 多一点<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >如果我们能够理解经济的增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们就可以理解其他的现象<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc szhuang'>
      <b
        >股票实际上是代表市场里规模以上的公司<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >GDP的增长很大意义上是由这些公司财务报表上销售额的增长来决定的<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        ></b
      >所以从数学上我们就会明白<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >为什么当GDP出现长期的持续增长的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >几乎所有股票加在一起的总指数会以这样的速度来增长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这是第一层次的结论<span unicode="ff1a" class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      >通货膨胀和GDP的增长是解释现金和股票表现差异的最根本原因<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      下面一个更重要的问题是<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >为什么在美国经济里出现了两百年这样长时间的GDP持续的<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >复利性的增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >同时通货膨胀率也一直都存在<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >为什么经济几乎每年都在增长<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >那么我们有没有办法去计量人类在过去几千年中GDP增长基本的形态是什么样的<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >有没有持续增长的现象<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      要回答这个问题<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们需要弄明白在人类历史上<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >在文明出现以后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >整体的GDP<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >整体的消费<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >生产水平呈现出一个什么样的变化状态<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      斯坦福大学一位全才教授莫瑞斯<span
        unicode="ff08"
        class="biaodian cjk bd-open bd-jiya"
        ><span>（</span></span
      >Ian Morris<span
        unicode="ff09"
        class="biaodian cjk bd-close bd-end bd-jiya"
        ><span>）</span></span
      >带领一个团队在过去十几年里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >通过现代科技的手段<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >对人类过去上万年历史里攫取和使用的能量进行了基本的计量做出来的结论<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >它的基本计量和我们今天讲的GDP关联度非常高<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >那么<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >在过去一万六千年里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >人类社会的基本GDP增长情况怎么样<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      但是到了近代以后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们看到在过去的三百年间<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >突然之间人类文明呈现了一个完全不同的状态<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >出现一个巨幅的增长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      要想理解股票在过去两百年的表现以及今后二十年的表现<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >必须看懂并能够解释这条线<span
        unicode="2014"
        class="biaodian cjk bd-liga bd-jiya"
        ><span>——</span></span
      >过去人类文明的基本图谱<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >不理解这个<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >很难在每次股灾的时候保持理性<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >每次到08年<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >09年这样的危机的时候都会觉得世界末日到了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      投资最核心的是对未来的预测<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >正如一句著名的笑话所言<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      ><span unicode="201c" class="biaodian cjk bd-open punct">“</span
      >预测很难<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >尤其是关于未来<span
        unicode="201d"
        class="biaodian cjk bd-close bd-end punct"
        >”</span
      ><span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我把人类文明分断成三大部分<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      第一部分是更早的狩猎时代<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >始于15万年以前真正意义上的人类出现以后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我叫它1.0文明<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      农业和畜牧业最早在两河流域出现的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >同样的变化在五六千年前从中国的黄河开始出现<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >带来人类文明第二次伟大的跃升<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这时<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们GDP的能力已经相当强<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我叫它2.0文明<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也就是农业和畜牧业文明<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这个文明状态持续了几千年<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      在此之后突然之间出现了GDP以稳定的速度每年都在增长的情况<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >以至于到今天我们认为GDP不增长是件很大的事<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >甚至于中国目前GDP的增长从10%跌到7%也成为一件大事<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这是一个非常现代的现象<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >可是也已经根深蒂固到每个人的心里<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >要理解这个现象<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也就是现代化<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我就姑且把它称之为3.0文明<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      整个经济出现了持续性的<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >累进性的<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >长期复利性的增长和发展<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这是 3.0 文明最大的特点<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >出现了现代金融产品的可投资价值<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这时才有可能讨论资产配置<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >股票和现金<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >当这个前提没有的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这些讨论都没有意义<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      因此要想了解投资<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >了解财富增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >一定要明白财富创造的根源在哪里<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >最主要的根源就是人类文明在过去两百年里GDP持续累进性的增长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >那么3.0文明的本质是什么呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >就是在这个时期<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >由于种种的原因<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >出现了现代科技和自由市场经济<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这两者的结合形成了我们看到的3.0文明<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <h4 class="szhuang">
      <b
        >NO2:什么是投资的大道<span
          unicode="ff1f"
          class="biaodian cjk bd-end bd-jiya"
          ><span>？</span></span
        >怎样成为优秀的投资人<span
          unicode="ff1f"
          class="biaodian cjk bd-end bd-jiya"
          ><span>？</span></span
        ></b
      >
    </h4>
    <p class='index-module_textWrap_3ygOc'>
      如果是这样的话<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >对个人投资者来说<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >比较好的办法是去投资股票<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >尽量避免现金<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >但这里面很大的一个问题就是<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票市场一直在上下波动<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而且在短期我们需要资产的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >它变化的量<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >时间常常会很长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      美国股市过去两百年平均回报率差不多是6.6%<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >每六十几年的回报率也差不多是这个数字<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >相对来说<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >比较稳定<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >可是当我们把时间放得更短一些的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你就会发现它的表现会很不一样<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      例如战后从1946年到1965年<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >美国股市的平均回报率是10%<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >比长期的要高很多<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      可是在下面的15年里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >1966-1981年<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >不仅没有增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而且连续15年价值都在跌<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      在接下来的16年里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >1982-1999年<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >又以更高的速度<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >13.6%的速度在增长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      可是接下来的13年<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >又开始进入一个持续的下跌的过程<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >整个13年的时间里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >价值是在下跌的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      所以才有凯恩斯著名的一句话<span
        unicode="ff1a"
        class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      ><span unicode="201c" class="biaodian cjk bd-open punct">“</span>In the
      longrun we are all dead.<span
        unicode="201d"
        class="biaodian cjk bd-close bd-end punct"
        >”</span
      >毕竟每一个人的时间是有限的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      有没有这样一种投资方法<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >不是旁门左道<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >可以不断被重复<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >学习<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >可以长期给我们带来这样的结果<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >这是我们下面要回答的问题<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      就我能够观察到的<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >能够用数据统计来说话的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >真正能够在长时间里面可靠<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >安全地给投资者带来优秀长期回报的投资理念<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >投资方法<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >投资人群只有一个<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就是价值投资<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      那么什么是价值投资呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >价值投资的理念只有四个<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >大家记住<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >只有四个<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >前三个都是巴菲特的老师本杰明•格雷厄姆的概念<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >最后一个是巴菲特自己的独特贡献<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      第一<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票不仅仅是可以买卖的证券<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >实际上代表的是对公司所有权的证书<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >是对公司的部分所有权<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这是第一个重要的概念<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >投资股票实际上是投资一个公司<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >公司随着GDP的增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >在市场经济持续增长的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >价值本身会被不断地创造<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >那么在创造价值的过程中<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >作为部分所有者<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们持有部分的价值也会随着公司价值的增长而增长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      如果我们以股东形式投资<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >支持了这个公司<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >那么我们在公司价值增长的过程中分得我们应得的利益<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这条道是可持续的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >什么叫正道<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >什么叫邪道<span unicode="ff1f" class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >正道就是你得到的东西是你应得的东西<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >所以这样的投资是一条大道<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >是一条正道<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >可愿意这样理解股票的人少之又少<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      第二<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >理解市场是什么<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      股票一方面是部分所有权<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >另一方面它确确实实也是一个可以交换的证券<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >可以随时买卖<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这个市场里永远都有人在叫价<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >那么怎么来理解这个现象呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >在价值投资人看来<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >市场的存在只是为了你来服务的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >能够给你提供机会<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >让你去购买所有权<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也会给你一个机会<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >在你很多年之后需要钱的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >能够把它出让<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >变成现金<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >所以市场的存在是为你而服务的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这个市场从来都不能告诉你<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >真正的价值是什么<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >它告诉你的只是价格是什么<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你不能把市场当作你的一个老师<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >你只能把它当作一个可以利用的工具<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这是第二个非常重要的观念<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >但这个观念又和几乎95%以上市场参与者的理解正好相反<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      第三<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >投资的本质是对未来进行预测<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而预测能得到的结果不可能是百分之百准确<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >只能是从零到接近一百<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >那么当我们做判断的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就必须要预留很大的空间<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >叫安全边际<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      因为你没有办法分辨<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >所以无论你多有把握的事情都要牢记安全边际<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你的买入价格一定要大大低于公司的内在价值<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这个概念是价值投资里第三个最重要的观念<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      因为有第一个概念<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票实际上是公司的一部分<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >公司本身是有价值的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >有内在的价值<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而市场本身的存在是为你来服务的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >所以你可以等着当市场价格远远低于内在价值的时候再去购买<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >当这个价格远远超出它的价值时就可以出卖<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这样一来如果对未来的预测是错误的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我至少不会亏很多钱<span
        unicode="ff1b"
        class="biaodian cjk bd-end bd-jiya"
        ><span>；</span></span
      >那么常常即使你的预测是正确的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >比如说你有80%<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >90%的把握<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但因为不可能达到100%<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >当那10%<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >20%的可能性出现的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这个结果仍然对你的内在价值是不利的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但这时如果你有足够的安全边际<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就不会损失太多<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      假如你的预测是正确的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你的回报就会比别人高很多很多<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >你每次投资的时候都要求一个巨大的安全边际<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这是投资的一种技能<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      第四<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >巴菲特经过自己五十年的实践增加了一个概念<span
        unicode="ff1a"
        class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      >投资人可以通过长期不懈的努力<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >真正建立起自己的能力圈<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >能够对某些公司<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >某些行业获得超出几乎所有人更深的理解<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而且能够对公司未来长期的表现<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >做出高出所有其他人更准确的判断<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >在这个圈子里面就是自己的独特能力<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      能力圈概念最重要的就是边界<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >没有边界的能力就不是真的能力<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >如果你有一个观点<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你必须要能够告诉我这个观点不成立的条件<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这时它才是一个真正的观点<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >如果直接告诉我就是这么一个结论<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >那么这个结论一定是错误的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >一定经不起考验<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      能力圈这个概念为什么很重要<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >是因为<span unicode="201c" class="biaodian cjk bd-open punct">“</span
      >市场先生<span unicode="201d" class="biaodian cjk bd-close bd-end punct"
        >”</span
      ><span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >市场存在的目的是什么<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >对于市场参与者而言<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >市场存在的目的就是发现人性的弱点<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >你自己有哪些地方没有真正弄明白<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你身上有什么样的心理<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >生理弱点<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >一定会在市场的某一种状态下曝露<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >所有在座曾经在市场里打过滚的一定知道我说这句话的含义<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      市场本身是所有人的组合<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >如果你不明白自己在做什么<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这个市场一定在某一个时刻把你打倒<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这就是为什么市场里面听到的故事都是大家赚钱的故事<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >最后的结果其实大家都亏掉了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >人们总能听到不同新人的故事<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >是因为老人都不存在了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这个市场本身能够发现你的逻辑<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >发现你身上几乎所有的问题<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你只要不在能力圈里面<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >只要你的能力圈是没有边界的能力圈<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >只要你不知道自己的边界<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >市场一定在某一个时刻某一种形态下发现你<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而且你一定会被它整得很惨<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      只有在这个意义上投资才真正是有风险的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这个风险不是股票价格的上上下下<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而是资本永久性的丢失<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这才是真正的风险<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这个风险是否存在<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就取决于你有没有这个能力圈<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >而且这个能力圈一定要非常狭小<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你要把它的边界<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >每一块边界<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >都定义得清清楚楚<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >只有在这个狭小的边界里面才有可能通过持续长期的努力建立起真正对未来的预测<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这是巴菲特本人提出的概念<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这四个方面合起来就构成了价值投资全部的含义<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >最根本的理念<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >价值投资的理念<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >不仅讲起来很简单<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >很清晰<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而且是一条大道<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >正道<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >正道就是可持续的东西<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >什么东西可持续<span unicode="ff1f" class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >可持续的东西都具有一个共同的特点<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就是你得到的东西在别人看来<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >在所有其他人看来<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >都是你应得的东西<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这就可持续了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这就是价值投资全部的理念<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >听起来非常地简单<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也非常合乎逻辑<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >可是现实的情况是什么样的<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >在真正投资过程中<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这样的投资人在整个市场里所占的比例少之又少<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >非常少<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      几乎所有跟投资有关的理论都有一大堆人在跟随<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但是真正的价值投资者却寥寥无几<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >于是投资的特点就是<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >大部分人不知道你做的是什么<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >投资的结果变成财富杀手<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >牛熊转换就是一个最好的例证<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      另外一个很难的地方是你对未来的判断也很难<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >投资的本事是对未来进行预测<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这需要很多年不懈的努力<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >需要很多年刻苦的学习<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >才能达到这样的境界<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      当你能够做出这个判断的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >你就开始建立自己的能力圈了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这个圈开始的时候一定非常狭小<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而建立这个圈子的时间很长很长<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这就是为什么价值投资本身是一条漫漫长途<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >虽然肯定会走到头<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但是绝大部分人不愿意走<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >它确实要花很多很多时间<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >即便花很多时间<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >了解的仍然很少<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      所以虽然这条路看起来是一条康庄大道<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但实际上它距离成功非常地遥远<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >很多人被这吓坏了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      同时因为这个市场总是让你感觉到短期可以获利<span
        unicode="2014"
        class="biaodian cjk bd-liga bd-jiya"
        ><span>——</span></span
      >你短期的资产确确实实可以有巨大的变化<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >所以这会给你幻觉<span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
        ><span>（</span></span
      >illusion<span
        unicode="ff09"
        class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
        ><span>）</span></span
      ><span
        unicode="ff0c"
        class="
          biaodian
          cjk
          bd-end bd-cop bd-hangable bd-jiya bd-consecutive
          end-portion
        "
        prev="bd-close bd-end"
        ><span>，</span></span
      >想象你在短期里可以获得巨大利益<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这样你会更倾向于希望把你的时间<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >精力<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >聪明才智放在短期的市场预测上<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这就是为什么大家愿意去抄近道<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >不愿意走大道<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >而实际上几乎所有的近道都变成了旁门左道<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      所以我们看到在长期<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >至少在美国的交易记录<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >几乎所有以短期交易为目的的各种各样的形形色色的所谓的战略<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >策略<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >几乎没有长期成功的记录<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >而那些真正长期的<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >优秀的投资记录中<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >几乎人人都是价值投资者<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <h4 class="szhuang">
      NO3:价值投资在中国是否适用<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </h4>
    <p class='index-module_textWrap_3ygOc'>
      下面我来讲一讲最后一个问题<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >既然价值投资是一个大道<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >它在中国能不能实现<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      在过去几百年里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票投资确实是在长期能够给投资人带来巨大利益的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我们也解释了为什么会是这样的情况<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >很多人在分析到很多事的时候都说中国是特殊的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我们确实在现实中也发现中国很多事情和西方<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >美国不一样<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >但是在这个问题上<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就是我们今天讨论的核心<span
        unicode="2014"
        class="biaodian cjk bd-liga bd-jiya"
        ><span>——</span></span
      >投资问题上<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >中国是不是特殊呢<span unicode="ff1f" class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这涉及到对未来几十年的预测<span
        unicode="ff1a"
        class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      >中国会是什么样子呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我谈谈我个人的看法<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >价值投资在中国能不能实现这个问题确实让我个人困惑了很多年<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >投资中国的公司意味着投资这个国家<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      首先我们还是用数据来说话<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我给大家看一下我们能够搜集到的过去的数据<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >对中国股市和其他市场的表现做一个比较<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >美国从1991年底到去年底的数据<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们看到其表现几乎和过去两百年的模式是一样的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票的投资在不断地增加价值<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而现金在不断地丢失价值<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这都是因为GDP的不断增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >和过去两百年基本上是一样的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      接下来我们看一看中国自1991年以来的数据<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >中国在1990年以后才出现老八股<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >1991年才出现了真正的股指<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我想请大家猜一猜<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >中国在这段时间里是什么样子呢<span
        unicode="ff1f"
        class="biaodian cjk bd-end bd-jiya"
        ><span>？</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我们看到的结果是<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >中国在过去二十年里的模式<span
        unicode="ff08"
        class="biaodian cjk bd-open bd-jiya"
        ><span>（</span></span
      >Pattern<span unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"
        ><span>）</span></span
      >几乎和美国过去两百年是一模一样的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      由于中国的GDP增长在这个阶段高于美国<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >直接导致的结果是它的通货膨胀率也高<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >现金丢失价值的速度也高<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票增长价值的速度也高<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >但是基本的形式一模一样<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这就很有意思了<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我们看到过去这二十几年里<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >当中国真正地开始走回到3.0文明本质的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >它的表现几乎和美国是一样的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >形态也是一模一样的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >虽然我们的速度要快一些<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >虽然上指和深指过去25年涨了15倍<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >年化回报率12%<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但是我相信所有的股民<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >包括在座的各位<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >没有一个得到这个结果的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >因为没有人过去在股票上的投资涨了15倍<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      但有一家从股市成立第一天开始就得到这个回报<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >那就是中国政府<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >中国政府从第一天就得到这个回报<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >大家担心中国的债务比例比较大<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但是大家常常忘掉中国政府还拥有这个回报<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >她在几乎所有的股份里面都占据大头<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >其它炒股的人没有一个人得到这样的结果<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      一开始的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >没有人认为中国会有和美国几乎同样的表现<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >因为我们走的路不一样<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >但当真正回到现代化本原<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >3.0文明本原的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >最后的结果实际都是一样的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      总的来说<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >中国是从大概1840年之后就一直在走现代化过程<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但一直没有完全明白现代化本质究竟是什么<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我们在1840年以后几乎尝试了所有各种各样的方式<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >到了1949年之后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >前30年走的又是另外一条路<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >实行的是集体经济<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >是完全的计划经济体制<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >我们几乎把其它可以试的方式都试了一遍<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      从70年代末开始我们尝试的路子终于回到了3.0文明的本质<span
        unicode="2014"
        class="biaodian cjk bd-liga bd-jiya"
        ><span>——</span></span
      >自由市场经济+现代科技<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >在此之前走了一百五十年<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >到最后发现全都不成功<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就这最近35年试了两个东西<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >一个是自由市场经济<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >一个是现代科技<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >政治制度也没有很大变化<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >文化也没有很大变化<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      但最近这35年我们发现整个中国所有的经济形态突然之间和其它的3.0文明惊人的一致<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      直到35年前<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们才真正回到3.0文明的核心<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也就是自由市场经济和现代的科学技术<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >可一旦走上了这条道路之后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我们就发现中国经济表现出和其他3.0文明经济非常惊人的相似性<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >就是我们刚才在这个图表里看到的<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票市场<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >大宗金融产品过去二<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >三十年的表现<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >包括个股<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >公司表现都很惊人<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      这样在全球化以后我们今天也可以有这样一个新的推论<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >就是现代化的铁律<span unicode="ff1a" class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      >当互相竞争的两个不同的系统<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >因为有1+1大于2和1+1大于4两种机制同时存在交互形成<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >交换的量越大<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >增量就越大<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >当一个系统一个市场的交换量比另外一个系统大的时候<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >它产生的附加值速度在不断加速<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >累进加速的过程最后导致最大的市场最后变成唯一的市场<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我们回过来看价值投资在中国的展望<span
        unicode="ff1a"
        class="biaodian cjk bd-end bd-jiya"
        ><span>：</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我认为中国今天的情况基本上是介于2.0文明和3.0现代科技文明之间<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >差不多2.5文明吧<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      我们还有很长的路要走<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也已经走了很长的路<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >所以我认为未来中国会继续在3.0文明主航道上走下去应该是个大概率的事情<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >因为她离开的成本会非常非常高<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >像中国这样一个文化<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >一个民族<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >如果对她的历史比较了解的话<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我认为她走这样的道路<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >尤其是大家已经明白了现代文明的本质后<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >再去走回头路的可能性是非常小的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      中国离开全球共同市场的几率几乎为0<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >中国要改变市场经济规则几乎也是非常小概率的事件<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      所以<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >中国在未来二三十年里持续保持在全球市场里<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >持续进行自由市场经济和高度现代科学技术的情况是一个大概率事件<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >中国经济走基本的3.0文明的主航道仍然是大概率事件<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >而我们看到真正3.0文明的主道其实和政治<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >文化关系不大<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而和<span unicode="201c" class="biaodian cjk bd-open punct">“</span
      >自由市场经济+现代科技<span
        unicode="201d"
        class="biaodian cjk bd-close bd-end punct"
        >”</span
      >关系极大<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >这是真正的本质<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这是很多投资人<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >尤其是西方投资人对中国最大的误解<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      只要中国继续走在3.0现代科技文明的路上<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >继续坚持主体自由市场经济和现代科学技术<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >基本上它的主要大类资产的表现<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >现金的表现大体会遵循过去三百年成熟市场经济国家基本的模式<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >经济仍然会坚持累进式的增长<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >连带着出现通货膨胀<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >股票表现仍然优于其它各大类金融资产<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >价值投资理念在中国与美国一样仍是投资的大道<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >正道<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >仍然可以带来持续稳定的回报<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >更加安全<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >可靠的投资回报<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >这就是我认为价值投资可以在中国实行的最根本性的一个原因<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      另外一个情况是<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >我认为价值投资不仅在中国可以被应用<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >甚至中国目前不成熟的阶段使价值投资人在中国具备更多的优势<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      原因主要是<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >今天中国在资本市场中所处的位置<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >资本市场70%仍然是散户<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >仍然是短期交易为主<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >包括机构<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也仍然是以短期交易为主要的目的<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >价格常常会大规模背离内在价值<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >也会产生非常独特的投资机会<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      如果你不被短期交易所左右<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >所迷惑<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >真正坚持长期的价值投资<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >那么你的竞争者会更少<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >成功的几率会更高<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      而且中国现在正在进行的经济转型<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >实际上是要让金融市场扮演越来越重要的融资角色<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >不再以银行间接融资为主<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >而让股票市场<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >债券市场成为主要资金来源<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >成为配置资源的主要工具<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      在这种情况下<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >金融市场的发展规模<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >机构化的程度<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >成熟度都会在接下来的时间里得到很大的提高<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >当然如果把眼光只限在眼前<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >很多人会抱怨政府对市场的干预过多<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >救市不当<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >等等<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >但是我认为如果把眼光放得长远一些<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >中国市场仍然是在向着更加市场化<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >更加机构化<span
        unicode="3001"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>、</span></span
      >更加成熟化的方向去发展<span
        unicode="ff0c"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>，</span></span
      >对于下一步经济发展会扮演更重要的角色<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class='index-module_textWrap_3ygOc'>
      真正的价值投资人应该会发挥越来越重要的作用<span
        unicode="3002"
        class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
        ><span>。</span></span
      >
    </p>
    <p class="free">（来源：南山之路）</p>

  </div>
</template>

<script>
export default {};
</script>

<style>
</style>